import { LaybyQuote } from '@dataModels/Layby/LaybyQuote';

export const defaultCheckoutData: CheckoutData = {
  basketId: '',
  ownershipType: 'Individual',
  applicantDetails: {},
  ownerDetails: {},
  companyDetails: {},
  vehicleDetails: {},
  ownerAddress: {},
  deliveryAddress: {},
  giftboxDeliveryAddress: {},
  giftingDetails: {},
  promoSubscribed: true,
  isDealerOrder: false
};

export type CheckoutData = {
  basketId: string;
  // paymentType: number;
  // total: number;
  // surcharge: number;
  // manufactureNow?: boolean;
  // ownerIsApplicant?: boolean;
  promoSubscribed: boolean;
  // isGift: boolean;
  // isLayby: boolean;
  // isAutopay: boolean;
  // isMultiPlate: boolean;
  isDealerOrder: boolean;
  ownershipType: 'Individual' | 'Company';
  // laybyPreferredPaymentDay: Date;
  // laybyQuote: LaybyQuote;
  applicantDetails: ApplicantDetails;
  ownerDetails: OwnerDetails;
  companyDetails: CompanyDetails;
  vehicleDetails: VehicleDetails;
  ownerAddress: Address;
  deliveryAddress: DeliveryAddress;
  // dealerDetails?: DealerDetails | null;
  // dealerAddress?: Address;
  // isAcceptStatement?: boolean;
  // giftingType?: number;
  // isGifting: boolean;
  giftingDetails: GiftingDetails;
  giftboxDeliveryAddress: Address;
};

// export type Checkout = {
//   paymentType: number
//   total: number
//   surcharge: number
//   manufactureNow: boolean
//   ownerIsApplicant: boolean
//   promoSubscribed: boolean
//   isGift: boolean
//   isLayby: boolean
//   isAutopay: boolean
//   isMultiPlate: boolean
//   isDealerOrder: boolean
//   ownershipType: "Individual" | "Company"
//   laybyPreferredPaymentDay: Date
//   laybyQuote: LaybyQuote
//   applicantDetails: ApplicantDetails
//   ownerDetails: OwnerDetails
//   companyDetails: CompanyDetails
//   vehicleDetails: VehicleDetails
//   ownerAddress: Address
//   deliveryAddress: Address & {
//     title: string
//     firstName: string
//     lastName: string
//     sameAsOwnerAddress: boolean
//     companyName: string
//   }
//   dealerDetails: DealerDetails | null
//   dealerAddress: Address
//   isAcceptStatement: boolean
//   giftingType: number
//   isGifting: boolean
//   giftingDetails: GiftingDetails
//   giftboxDeliveryAddress: Address
// }
export type ApplicantDetails = {
  title?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
};
export type CompanyDetails = {
  companyNumber?: string;
  companyOwner?: string;
};
export type VehicleDetails = {
  driverLicense?: string;
  dob?: Date | null;
  existingCombination?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vosa?: string[];
};
export type Address = {
  fullAddress?: string;
  street?: string;
  building?: string;
  unit?: string;
  suburb?: string;
  city?: string;
  postCode?: string;
  isManualAddress?: boolean;
};
export type DeliveryAddress = Address & {
  title?: string;
  firstName?: string;
  lastName?: string;
  sameAsOwnerAddress?: boolean;
  companyName?: string;
};
export type OwnerDetails = {
  title?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
};
export type DealerDetails = {
  dealerId: number;
  salesPersonId: number;
  dealerName: string;
  salesPersonName: string;
  salesPersonEmail: string;
  distributionId: number;
};
export type GiftingDetails = {
  to?: string;
  from?: string;
  isForMe?: boolean;
  message?: string;
};
